module.exports = __webpack_public_path__ + "static/media/morning-mist.9f62ba63.jpg";